import(/* webpackMode: "eager" */ "/rishi-s-gay/app/global-error.tsx")